// src/data/NewsData.jsx
import React from "react";

/* ========= Local images ========= */
import blog01 from "./../assets/AyurvedaAssets/images/blog/blog-01.jpg";
import blog02 from "./../assets/AyurvedaAssets/images/blog/blog-02.jpg";
import blog03 from "./../assets/AyurvedaAssets/images/blog/blog-03.jpg";
import blog04 from "./../assets/AyurvedaAssets/images/blog/blog-04.jpg";
import blog05 from "./../assets/AyurvedaAssets/images/blog/blog-05.jpg";
import blog06 from "./../assets/AyurvedaAssets/images/blog/blog-06.jpg";
import News2  from "./../assets/AyurvedaAssets/images/blog/News-2.jpg";
import News3  from "./../assets/AyurvedaAssets/images/blog/News-3.jpg";
import News4  from "./../assets/AyurvedaAssets/images/blog/News-4.jpg";
import News5  from "./../assets/AyurvedaAssets/images/blog/News-5.jpg";
import News6  from "./../assets/AyurvedaAssets/images/blog/News-6.jpg";
import News7  from "./../assets/AyurvedaAssets/images/blog/News-7.jpg";
import News8  from "./../assets/AyurvedaAssets/images/blog/News-8.jpg";
import News9  from "./../assets/AyurvedaAssets/images/blog/News-9.jpg";
import News10 from "./../assets/AyurvedaAssets/images/blog/News-10.jpg";
import News11 from "./../assets/AyurvedaAssets/images/blog/News-11.jpg";
import News12 from "./../assets/AyurvedaAssets/images/blog/News-12.jpg";
import YoutubeJaipurImage from "./../assets/AyurvedaAssets/images/blog/YoutubeJaipurImage.jpg";

/* ========= Data =========
   First item = YouTube Community Post.
   We show a local cover (News12) and link out to YouTube.
*/
const NewsData = [
  {
    url: "https://www.youtube.com/post/UgkxgHhhpUqqRPO4xItx5-Q4GrkgB2JUMX70",
    title: "YouTube Community Post — Jaipur Camp Highlights",
    img: YoutubeJaipurImage,
    time: "Recent",
    comments: "10",
    type: "post",
  },

  { img: News12, time: "Recent",        comments: "10 Comment", title: "Bharat Dhara - News" },
  { img: blog01, time: "2 months ago",  comments: "10 Comment", title: "Bharat Dhara - News" },
  { img: News2,  time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
  { img: News3,  time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
  { img: News4,  time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
  { img: News5,  time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
  { img: News6,  time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
  { img: News7,  time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
  { img: News8,  time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
  { img: News9,  time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
  { img: News10, time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
  { img: News11, time: "2 months ago",  comments: "05 Comment", title: "Bharat Dhara - News" },
];

export default NewsData;

/* ========= UI (no blog-single.html; full-card external link) ========= */

const isUrl = (u = "") => /^https?:\/\//i.test(u);

function NewsCard({ item }) {
  const src = item?.img || "/fallback.jpg";

  const Content = () => (
    <>
      <div className="relative w-full overflow-hidden rounded-xl bg-gray-100">
        <div className="relative w-full aspect-[16/9]">
          <img
            src={src}
            alt={item.title}
            loading="lazy"
            width="1280"
            height="720"
            className="absolute inset-0 h-full w-full object-cover"
            onError={(e) => (e.currentTarget.src = "/fallback.jpg")}
          />
          {/* If you place ribbons/badges, keep them non-interactive */}
          {item.type === "post" && (
            <div className="pointer-events-none absolute left-3 top-3 rounded-md bg-white/90 px-2 py-1 text-[12px] shadow">
              Community post
            </div>
          )}
        </div>
      </div>

      <h3 className="mt-3 text-lg sm:text-xl font-semibold leading-snug">
        {item.title}
      </h3>

      {(item.time || item.comments) && (
        <p className="mt-1 text-sm text-gray-600">
          {item.time}{item.comments ? ` • ${item.comments}` : ""}
        </p>
      )}
    </>
  );

  // ✅ Entire card is the anchor when external URL exists.
  // No internal template links, no blog-single.html.
  return isUrl(item.url) ? (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      className="block focus:outline-none focus:ring-2 focus:ring-green-600 rounded-xl"
    >
      <Content />
    </a>
  ) : (
    <div className="block">
      <Content />
    </div>
  );
}

export function NewsGrid({ items = NewsData }) {
  return (
    <section className="mx-auto max-w-6xl px-4">
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item, idx) => (
          <NewsCard key={idx} item={item} />
        ))}
      </div>
    </section>
  );
}

/* ========= Usage =========
import NewsData, { NewsGrid } from "@/data/NewsData";
// <NewsGrid items={NewsData} />
*/
